import * as yup from 'yup';

export const CommonUpdate = {
    schema: {
        username: yup.string().nullable().required('Username  is required'),
        email: yup
            .string()
            .nullable()
            .email('Please enter a valid email')
            .required('Email is required'),
        country_code: yup.object().nullable(),
        phone_number: yup.string().required('Phone number is required'),
        name: yup.string().nullable().required('First name is required'),
        surname: yup.string().nullable().required('Last name is required'),
        is_delivery_manager_on_board: yup.boolean(),
    },
    defaultValues: {
        id_yacht: null,
        username: '',
        name: '',
        surname: '',
        email: '',
        country_code: null,
        phone_number: '',
        is_delivery_manager_on_board: false,
    },
    fields: [
        {
            id: 'yacht_divider',
            type: 'divider',
            label: 'Yacht',
            xs: 12,
        },
        {
            id: 'yacht_name',
            name: 'yacht_name',
            type: 'text',
            label: 'Yacht',
            required: true,
            disabled: true,
            xs: 12,
        },
        {
            id: 'user_divider',
            type: 'divider',
            label: 'User Info',
            xs: 12,
        },
        {
            id: 'username',
            name: 'username',
            type: 'text',
            label: 'Username',
            xs: 12,
            sm: 6,
            required: true,
        },
        {
            id: 'email',
            name: 'email',
            type: 'text',
            label: 'Email',
            xs: 12,
            sm: 6,
            required: true,
        },
        {
            id: 'name',
            name: 'name',
            type: 'text',
            label: 'First Name',
            xs: 12,
            sm: 6,
            required: true,
        },
        {
            id: 'surname',
            name: 'surname',
            type: 'text',
            label: 'Last Name',
            xs: 12,
            sm: 6,
            required: true,
        },
        {
            id: 'country_code',
            name: 'country_code',
            type: 'country-autocomplete',
            label: 'Country Code',
            required: false,
            xs: 6
        },
        {
            id: 'phone_number',
            name: 'phone_number',
            type: 'text',
            label: 'Phone Number',
            required: true,
            xs: 6
        },
        {
            id: 'is_delivery_manager_on_board',
            name: 'is_delivery_manager_on_board',
            type: 'switch',
            label: 'Manager on Board',
            required: false,
            xs: 12,
        },
    ],
};
